export const ListQueryKey = 'cates';
export const DetailQueryKey = 'cate';

export const Urls = {
  selectUrl: '/commodityCategory/list',
  updateUrl: '/commodityCategory/update',
  deleteUrl: '/commodityCategory/delete',
  createUrl: '/commodityCategory/create',
  detailUrl: '/commodityCategory/detail',
};
